import { connect } from 'react-redux';

import {
  getEventName,
  getEventSplitColumn,
  getMetainf,
  getPeriodsState,
} from '../../reducers/analyticsApp';
import { prepareDropdown } from '../../utils/common';
import EventsFieldOption from '../../components/event/FieldOption';
import { splitByExcludeFields } from '../../constants/metainf';
import { setEventSplitColumn } from '../../actions/events/csvEvents';

const mapStateToProps = (state, { id }) => {
  const metainf = getMetainf(state, getEventName(state, id));
  // если есть доп периоды - дисаблим
  const { periods } = getPeriodsState(state, id);
  const firstPeriodIsEmpty = periods[0].from === '' && periods[0].to === '';

  const disabled = periods.length > 1 || !firstPeriodIsEmpty;

  return {
    label: 'Split by:',
    value: getEventSplitColumn(state, id),
    values: prepareDropdown(metainf, false, splitByExcludeFields),
    visible: true,
    disabled,
  };
};

const mapDispatchToProps = (dispatch, { id }) => ({
  onChange: (value) => dispatch(setEventSplitColumn(id, value)),
});

const EventsSplitByFieldOption = connect(mapStateToProps, mapDispatchToProps)(EventsFieldOption);

export default EventsSplitByFieldOption;
